module.exports = __webpack_public_path__ + "static/15-52dd4eb53acec4836e378acdf59b6de9.jpg";